var _defs, _polygon, _polygon2, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlashcallLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "slashcall-logo-white",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 390 1080 215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "scwGradA",
    x1: 193.07,
    y1: 432.74,
    x2: 117.92,
    y2: 599.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02c2fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4436f4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "scwGradB",
    x1: 176.66,
    y1: 384.75,
    x2: 101.52,
    y2: 551.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02c2fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#06b9fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#11a3fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2282fe"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#scwGradA)",
    points: "140.83 594.84 82.23 594.84 165.44 447.64 224.03 447.64 140.83 594.84"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#scwGradB)",
    points: "124.42 546.85 65.83 546.85 149.03 399.65 207.63 399.65 124.42 546.85"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    fontFamily: "Poppins, sans-serif",
    fontWeight: 500,
    fontSize: 183.9,
    letterSpacing: -7.36,
    transform: "translate(244.92 573.32)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Slashcall"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlashcallLogoWhite);
export default __webpack_public_path__ + "static/media/slashcall-logo-white.53ea81dec50c88fcbb23b54f86326eb0.svg";
export { ForwardRef as ReactComponent };